import React, { useEffect, useCallback, useRef } from 'react';
import { Scrollbar, CircularProgress, Alert } from '@ann/web-components';
import {
  MainContainer,
  ConfigPageContainer,
  CircularProgressContainer,
} from './ConfigPage.styled';
import {
  ProfileImageSection,
  BasicInfoSection,
  ChatStartersSection,
  ModelSection,
} from './components';
import { useAgent } from '../../context';
import { updateAgent } from '../../../../../services/agents';

const AUTOSAVE_DELAY = 1500;

const ConfigPage = () => {
  const {
    agent,
    loading,
    error,
    hasUnsavedChanges,
    markAsSaved,
    setAgentName,
    setAgentDescription,
    setAgentModel,
    setAgentPhotoUrl,
    addStarter,
    removeStarter,
  } = useAgent();

  const [isSaving, setIsSaving] = React.useState(false);
  const [showSaveAlert, setShowSaveAlert] = React.useState(false);
  const saveTimeoutRef = useRef(null);

  // Autosave con debounce
  useEffect(() => {
    if (hasUnsavedChanges && agent?.uuid) {
      // Limpiar timeout anterior
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }

      // Programar nuevo guardado
      saveTimeoutRef.current = setTimeout(() => {
        handleSave();
      }, AUTOSAVE_DELAY);
    }

    return () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
    };
  }, [hasUnsavedChanges, agent]);

  // Función de guardado
  const handleSave = useCallback(async () => {
    if (!agent?.uuid || isSaving) return;

    setIsSaving(true);
    setShowSaveAlert(true);

    try {
      await updateAgent(agent.uuid, {
        name: agent.name,
        description: agent.description,
        model: agent.model,
        starters: agent.starters,
        metadata: {
          imageUrl: agent.photoUrl,
        },
      });

      markAsSaved();
    } catch (err) {
      console.error('Error saving agent:', err);
    } finally {
      setIsSaving(false);
      setTimeout(() => setShowSaveAlert(false), 2000);
    }
  }, [agent, isSaving, markAsSaved]);

  if (loading) {
    return (
      <CircularProgressContainer>
        <CircularProgress size="xl" />
      </CircularProgressContainer>
    );
  }

  if (error) {
    return <div>Error: {error.message || 'Error loading agent'}</div>;
  }

  return (
    <MainContainer>
      <Scrollbar size="small">
        <ConfigPageContainer>
          {/* <ProfileImageSection
            imageUrl={agent.photoUrl}
            onImageChange={setAgentPhotoUrl}
            agentName={agent.name}
          /> */}

          <BasicInfoSection
            name={agent.name}
            description={agent.description}
            onNameChange={setAgentName}
            onDescriptionChange={setAgentDescription}
          />

          <ChatStartersSection
            chatStarters={agent.starters}
            onAddStarter={addStarter}
            onRemoveStarter={removeStarter}
          />

          {/* <ModelSection
            model={agent.model}
            onModelChange={setAgentModel}
          /> */}
        </ConfigPageContainer>
      </Scrollbar>

      {showSaveAlert && (
        <Alert
          title="Autosave"
          description={isSaving ? 'Saving changes...' : 'Changes saved!'}
          severity="info"
          maxWidth="500px"
          closable={false}
          autoClose={true}
          autoCloseDelay={3000}
        />
      )}
    </MainContainer>
  );
};

export default ConfigPage;
